// extracted by mini-css-extract-plugin
export default {"no-scroll":"RD43NXDysAA5AtK3Cp39__no-scroll___","smallScreenWarning":"sXD64fBXGD0lCYggf54o__smallScreenWarning___","content":"nN1jWp0zxC1W51rftolq__content___"};